import {Component, HostBinding, OnDestroy} from '@angular/core';
import {QuestionComponent} from '../question/question.component';
import {TRANSLATION_EDITOR_SCOPE} from '../../../constants';
import {KEYS} from '../../../translation-keys';
import {Translatable} from '@ngmedax/translation';
import {flashFocus} from '../../services/focus-flash';


@Component({
  selector: 'app-qa-page-break',
  templateUrl: './page-break.component.html',
  styleUrls: [
    '../question/question.component.css',
    '../../shared/reusable.css'
  ]
})
@Translatable({scope: TRANSLATION_EDITOR_SCOPE, keys: KEYS})
export class PageBreakComponent extends QuestionComponent implements OnDestroy {
  private titleChangeTimeout: any = null;

  /**
   * Page view shows the page title above the questions instead of this card. The card stays in the list with zero
   * height: dragging maps DOM positions to question positions and drops always land before the page break
   */
  @HostBinding('class.qa-page-break-collapsed')
  public get collapsedInPageView(): boolean {
    return this.pageViewEnabled;
  }

  /** The page title is a plain input, the froala focus request of questions doesn't reach it */
  public async focusProperty(field: 'title' | 'description' | 'options', event: Event): Promise<void> {
    await super.focusProperty(field, event);
    requestAnimationFrame(() => setTimeout(() => {
      const input = document.getElementById('page-break-title-' + this.question.id);
      if (input && this.selected) {
        input.focus();
        flashFocus(input);
      }
    }, 0));
  }

  /**
   * Called when the page title changes.
   * Debounces the update to avoid triggering on every keystroke.
   */
  public onTitleChange(): void {
    if (this.titleChangeTimeout) {
      clearTimeout(this.titleChangeTimeout);
    }

    this.titleChangeTimeout = setTimeout(() => {
      this.state.updateElement(this.question, this.position);
      this.titleChangeTimeout = null;
    }, 300);
  }

  /**
   * Cleanup timeout on destroy.
   */
  public ngOnDestroy(): void {
    super.ngOnDestroy();

    if (this.titleChangeTimeout) {
      clearTimeout(this.titleChangeTimeout);
    }
  }
}
